<section class="edit-route__points">

  @if (insertAddNewPointCardBeforeFirstCard()) {
    <app-add-new-point-card 
      [previousEditedPoint]="null"
      [nextEditedPoint]="dailyEditedPointsToRender.length > 0 ? dailyEditedPointsToRender[0] : null"
      [orderIndex]="0"
    />
  }
  
  @if (dailyEditedPointsToRender.length > 0) {
    
    @for (editedPoint of dailyEditedPointsToRender; track editedPoint.id; let i = $index) {
      <!-- dont show the lodging as a point to edit (id = 0) -->
      @if (editedPoint.id !== 0) {
        <div
          #swiper
          class="points__swiper swiper"
        >
          <ul class="swiper-wrapper">
            <li class="swiper-slide">
              <app-card 
                [img]="editedPoint.img"
                [title]="editedPoint.title"
                [startDate]="editedPoint.startDate"
                [durationMinutes]="editedPoint.duration"
                [isPointToAddNew]="isPointToAddNew(editedPoint.id, editedPoint.type)"
                [isPointToDelete]="isPointToDelete(editedPoint.id, editedPoint.type)"
                [isPointToReplace]="isPointToReplace(editedPoint.id, editedPoint.type)"
              />
            </li>
            <li class="swiper-slide">
              <app-actions-card 
                [point]="editedPoint"
                [orderIndex]="i"
                [previousEditedPoint]="i > 0 ? dailyEditedPointsToRender[i - 1] : null"
                [nextEditedPoint]="i < dailyEditedPointsToRender.length - 1 ? dailyEditedPointsToRender[i + 1] : null"
                [isPointToAddNew]="isPointToAddNew(editedPoint.id, editedPoint.type)"
                [isPointToDelete]="isPointToDelete(editedPoint.id, editedPoint.type)"
                [isPointToReplace]="isPointToReplace(editedPoint.id, editedPoint.type)"
                (goToFirstSlide)="handleGoToFirstSlide()"
              />
            </li>
          </ul>
          
          <button
            class="swiper-button-next"
            [attr.aria-label]="'Siguiente' | translate"
          ></button>
        </div>
        
        @if (insertAddNewPointCardAfterCurrentCard(i)) {
          <app-add-new-point-card 
            [previousEditedPoint]="editedPoint"
            [nextEditedPoint]="i < dailyEditedPointsToRender.length - 1 && dailyEditedPointsToRender[i + 1].id !== 0 ? dailyEditedPointsToRender[i + 1] : null"
            [orderIndex]="i + 1"
          />
        }
      }
    }
  } @else {
    <app-add-new-point-card 
      [previousEditedPoint]="null"
      [nextEditedPoint]="null"
      [orderIndex]="0"
    />
  }
</section>